import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import { constantsApp } from "../../../constants/constants.app";

const useStyles = makeStyles({
  root: {
    width: "100%",
    overflowX: "auto"
  },
  table: {
    minWidth: 650
  }
});

function createData(name, rut, car, plate, status, time) {
  return { name, rut, car, plate, status, time };
}

const rows = [
  createData("Juan Perez", "18654789-6", "Nissan", "xere13", "in", "8:00 am"),
  createData(
    "Pedro Fernandez",
    "18654789-6",
    "Chevrollet",
    "abce32",
    "on hold",
    "9:10 am"
  ),
  createData(
    "Mria del Carmen",
    "18654789-6",
    "Nissan",
    "febh23",
    "out",
    "12:30 pm"
  ),
  createData(
    "Diego Rodriguez",
    "18654789-6",
    "Toyota",
    "resa26",
    "out",
    "12:45 pm"
  ),
  createData("Juana Fundez", "18654789-6", "Audi", "fere23", "in", "14:00 pm")
];

export default function SimpleTable() {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{constantsApp.components.worker.table.NAME}</TableCell>
            <TableCell align="right">
              {constantsApp.components.worker.table.ID}
            </TableCell>
            <TableCell align="right">
              {constantsApp.components.worker.table.VEHICLE}
            </TableCell>
            <TableCell align="right">
              {constantsApp.components.worker.table.PLATE}
            </TableCell>
            <TableCell align="right">
              {constantsApp.components.worker.table.STATUS}
            </TableCell>
            <TableCell align="right">
              {constantsApp.components.worker.table.TIME}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.rut}</TableCell>
              <TableCell align="right">{row.car}</TableCell>
              <TableCell align="right">{row.plate}</TableCell>
              <TableCell align="right">{row.status}</TableCell>
              <TableCell align="right">{row.time}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        rowsPerPage={10}
        component="div"
        onChangePage={() => console.log()}
        page={0}
        count={rows.length}
        backIconButtonProps={{
          "aria-label": "previous page"
        }}
        nextIconButtonProps={{
          "aria-label": "next page"
        }}
      />
    </Paper>
  );
}
